export default "__VITE_ASSET__Bk1iTeI8__"